import React from "react";
import classnames from "classnames";
import RegionDropdown from "Utils/RegionDropdown";

const standardRegionDropdown = props => {
  const {
    input,
    className,
    meta: { touched, error },
    ...others
  } = props;

  return (
    <RegionDropdown
      {...input}
      {...others}
      className={classnames({
        [className]: className,
        error: touched && error
      })}
    />
  );
};

export default standardRegionDropdown;
